import { colors } from './colors';

export const buttons = {
  primary: {
    color: colors.white,
    backgroundColor: colors.primary.main,
    outline: 'none',
    '&:disabled': {
      backgroundColor: colors.disabled,
    },
    '&:hover:not(:disabled)': {
      backgroundColor: colors.primary.dark,
    },
    '&:active:not(:disabled)': {
      backgroundColor: colors.primary.dark,
    },
  },
  secondary: {
    color: '#422AA9',
    backgroundColor: colors.primary.light,
    outline: 'none',
    '&:disabled': {
      backgroundColor: colors.disabled,
    },
    '&:hover:not(:disabled)': {
      backgroundColor: colors.primary.light,
    },
    '&:active:not(:disabled)': {
      backgroundColor: colors.primary[400],
    },
  },
  danger: {
    color: colors.white,
    backgroundColor: colors.destructive.main,
    '&:disabled': {
      backgroundColor: colors.disabled,
    },
    '&:hover:not(:disabled)': {
      backgroundColor: '#de3109',
    },
    '&:active:not(:disabled)': {
      backgroundColor: '#ea5b3a',
    },
  },
  primaryOutlined: {
    color: colors.primary.main,
    border: `1px solid ${colors.primary}`,
    backgroundColor: 'transparent',
    '&:disabled': {
      color: colors.disabled,
      borderColor: colors.disabled,
    },
    '&:hover:not(:disabled)': {
      backgroundColor: colors.primary,
      color: colors.white,
    },
  },
  ghost: {
    color: colors.text,
    border: `none`,
    backgroundColor: 'transparent',
    '&:disabled': {
      color: colors.disabled,
      borderColor: colors.disabled,
    },
    '&:hover:not(:disabled)': {
      color: colors.textSecondary,
    },
  },
  errorOutlined: {
    color: colors.error,
    border: `1px solid ${colors.error}`,
    backgroundColor: 'transparent',
    '&:disabled': {
      color: colors.disabled,
      borderColor: colors.disabled,
    },
    '&:hover:not(:disabled)': {
      backgroundColor: colors.error,
      color: colors.white,
    },
  },
  dangerOutlined: {
    color: colors.danger,
    border: `1px solid ${colors.danger}`,
    backgroundColor: 'transparent',
    '&:disabled': {
      color: colors.disabled,
      borderColor: colors.disabled,
    },
    '&:hover:not(:disabled)': {
      backgroundColor: colors.danger,
      color: colors.white,
    },
  },
  default: {
    color: colors.textSecondary,
    border: `1px solid ${colors.disabled}`,
    backgroundColor: colors.white,
    outline: 'none',
    '&:disabled': {
      backgroundColor: colors.disabled,
    },
    '&:hover:not(:disabled)': {
      backgroundColor: colors.greys[200],
    },
    '&:active:not(:disabled)': {
      backgroundColor: colors.greys[100],
    },
  },
};
